// eslint-disable-next-line no-undef
define('Tavano.TTUserActivityTracking', ['Tavano.TTUserActivityTracking.Model', 'jQuery', 'underscore'], function (
  TTUserActivityTrackingModel,
  jQuery,
  _
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      /** @type {EnvironmentComponent} */
      var environment = container.getComponent('Environment');

      /**Finshing execution when SSR - Server Side Rendering or SEO */
      if (environment.isPageGenerator()) {
        return;
      }

      /** @type {CheckoutComponent} */
      var checkout = container.getComponent('Checkout');
      /** @type {LayoutComponent} */
      var layout = container.getComponent('Layout');

      var trackModel = new TTUserActivityTrackingModel();

      var trackers = {
        updateUserActivityTracking: function () {
          container
            .getComponent('UserProfile')
            .getUserProfile()
            .done(function (userProfile) {
              var trackInfoStr = null;

              if (userProfile) {
                // Check if user is logged in
                if (userProfile.isloggedin) {
                  // update end time in localStorage
                  trackInfoStr = localStorage.getItem('track|' + userProfile.internalid);

                  // Check if trackInfoStr is not null
                  if (trackInfoStr) {
                    var trackInfo = JSON.parse(trackInfoStr);
                    trackInfo.end = new Date().getTime();
                    localStorage.setItem('track|' + userProfile.internalid, JSON.stringify(trackInfo));
                  }
                } else {
                  // get All tracking info from localStorage that start with 'tack|'
                  var trackKeyList = Object.keys(localStorage).filter(function (key) {
                    return key.startsWith('track|');
                  });

                  _.forEach(trackKeyList, function (trackKey) {
                    // If user is not logged in, check if the tracking info exists in localStorage
                    trackInfoStr = localStorage.getItem(trackKey);

                    if (trackInfoStr) {
                      var trackData = JSON.parse(trackInfoStr);

                      (function (keyToRemove) {
                        // Synchronize the tracking info with the server
                        trackModel.save(trackData).done(function () {
                          localStorage.removeItem(keyToRemove);
                        });
                      })(trackKey);
                    }
                  });
                }
              }
            });
        }
      };
      environment.addTracker(trackers);

      if (checkout) {
        // Tracking Login
        jQuery(document).ajaxSuccess(function (event, xhr, settings) {
          var loginServicePath = 'services/Account.Login.Service.ss';
          var loginMethod = 'POST';
          if (settings.url.includes(loginServicePath) && settings.type === loginMethod) {
            // If user is logged in an internalid is returned
            if (xhr.responseJSON && xhr.responseJSON.user && xhr.responseJSON.user.internalid) {
              var userid = xhr.responseJSON.user.internalid;
              // Set user login time in localStorage
              localStorage.setItem(
                'track|' + userid,
                JSON.stringify({user: userid, start: new Date().getTime(), end: null})
              );
            }
          }
        });
      }

      if (layout) {
        layout.on('afterShowContent', function () {
          environment.triggerEvent('updateUserActivityTracking', {});
        });
      }
    }
  };
});
